export const googleMapLink = (lat, lng) => {
    return `https://www.google.com/maps/?q=${lat},${lng}`
}

export const calculateArea2D = (positions) => {
    if (positions.length < 3) return 0; // Không đủ điểm để tạo thành đa giác

    let area = 0;
    const n = positions.length;

    for (let i = 0; i < n; i++) {
        const { latitude: x1, longitude: y1 } = positions[i];
        const { latitude: x2, longitude: y2 } = positions[(i + 1) % n]; // Điểm tiếp theo, vòng lại điểm đầu tiên
        area += x1 * y2 - y1 * x2;
    }

    return Math.abs(area / 2); // Diện tích tuyệt đối
};


const toRadians = (degree) => degree * (Math.PI / 180);

// Hàm tính diện tích đa giác trên bề mặt cầu
export const calculateArea = (coordinates) => {
    const R = 6371;  // Bán kính Trái Đất (km)
    let area = 0;

    // Duyệt qua tất cả các điểm trong polygon (bao gồm cả nối điểm cuối về điểm đầu)
    for (let i = 0; i < coordinates?.length - 1; i++) {
        const p1 = coordinates[i];
        const p2 = coordinates[i + 1];

        const lon1 = toRadians(p1[0]); // Kinh độ
        const lat1 = toRadians(p1[1]); // Vĩ độ
        const lon2 = toRadians(p2[0]); // Kinh độ
        const lat2 = toRadians(p2[1]); // Vĩ độ

        // Cộng diện tích giữa mỗi cặp điểm (theo công thức diện tích trên mặt cầu)
        area += (lon2 - lon1) * (Math.sin(lat1) + Math.sin(lat2));
    }

    // Diện tích theo đơn vị km²
    return Math.abs(area) * R * R / 2;
};


// Hàm tính khoảng cách giữa hai điểm sử dụng công thức Haversine
export const haversineDistance = (lon1, lat1, lon2, lat2) => {


    // Bán kính Trái Đất (km)
    const R = 6371;

    // Chuyển đổi tọa độ từ độ sang radians
    const φ1 = toRadians(lat1);
    const φ2 = toRadians(lat2);
    const Δφ = toRadians(lat2 - lat1);
    const Δλ = toRadians(lon2 - lon1);

    // Áp dụng công thức Haversine
    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // Tính khoảng cách (km)
    const distance = R * c;
    return distance;
};
export const findCenter = (locations) => {
    const totalCoords = locations?.length;

    // Tính tổng các giá trị latitude và longitude
    const total = locations.reduce(
        (acc, curr) => {
            return {
                longitude: acc.longitude + curr.position.longitude,
                latitude: acc.latitude + curr.position.latitude
            };
        },
        { longitude: 0, latitude: 0 }
    );

    // Tính trung bình latitude và longitude
    const center = {
        longitude: total.longitude / totalCoords,
        latitude: total.latitude / totalCoords
    };

    return center;
};
// Hàm tính toán tọa độ trung tâm của nhiều GeoJSON
export function getCenterOfMultipleGeoJSON(geoJsonDatas) {
    let overallMinX = Infinity, overallMinY = Infinity, overallMaxX = -Infinity, overallMaxY = -Infinity;

    // Lặp qua tất cả các GeoJSON để tính toán bounding box tổng hợp
    if (Array.isArray(geoJsonDatas)) geoJsonDatas?.forEach(geoJsonData => {
        const extent = getBoundingBox(geoJsonData);

        overallMinX = Math?.min(overallMinX, extent?.[0]);
        overallMinY = Math?.min(overallMinY, extent?.[1]);
        overallMaxX = Math?.max(overallMaxX, extent?.[2]);
        overallMaxY = Math?.max(overallMaxY, extent?.[3]);
    });
    const center = [
        (overallMinX + overallMaxX),  // Trung tâm về kinh độ (longitude)
        (overallMinY + overallMaxY)    // Trung tâm về vĩ độ (latitude)
    ];
    return center;
}
function getBoundingBox(geoJsonData) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

    if (Array.isArray(geoJsonData?.features)) geoJsonData?.features?.forEach(feature => {
        const geometry = feature?.geometry;

        if (geometry?.type === 'Point') {
            // Nếu là Point, chỉ lấy tọa độ trực tiếp
            const [x, y] = geometry?.coordinates;
            minX = Math?.min(minX, x);
            minY = Math?.min(minY, y);
            maxX = Math?.max(maxX, x);
            maxY = Math?.max(maxY, y);
        } else if (geometry?.type === 'Polygon') {
            // Nếu là Polygon, tính bounding box từ các tọa độ đỉnh
            if (Array.isArray(geometry?.coordinates?.[0])) geometry?.coordinates?.[0]?.forEach(([x, y]) => {
                minX = Math?.min(minX, x);
                minY = Math?.min(minY, y);
                maxX = Math?.max(maxX, x);
                maxY = Math?.max(maxY, y);
            });
        }
    });

    return [minX, minY, maxX, maxY];
}
export const findBounds = (locations) => {
    if (locations?.length === 0) {
        throw new Error("No locations provided");
    }
    // Khởi tạo giá trị ban đầu
    let east = locations?.[0]?.position?.longitude;
    let west = locations?.[0]?.position?.longitude;
    let north = locations?.[0]?.position?.latitude;
    let south = locations?.[0]?.position?.latitude;

    // Duyệt qua các vị trí và cập nhật giá trị cho east, west, north, south
    locations?.forEach(location => {
        const { longitude, latitude } = location?.position;

        // Kiểm tra nếu giá trị là số hợp lệ
        if (typeof longitude !== 'number' || typeof latitude !== 'number') {
            throw new Error("Invalid latitude or longitude value");
        }

        if (longitude > east) east = longitude;
        if (longitude < west) west = longitude;
        if (latitude > north) north = latitude;
        if (latitude < south) south = latitude;
    });

    return { east, west, north, south };
};

export const convertMtoKm = (m: number): string => {
    return m > 100 ? `${(m / 1000)?.toFixed(2)} km` : `${m?.toFixed(2)} m`;
};

export const convertM2toKm2 = (m2: number): string => {
    if (m2) return m2 > 10000 ? `${(m2 / 1000000)?.toFixed(4)} km²` : `${m2?.toFixed(4)} m²`;
    return null
};

export function calculateCenter(features) {
    // Tính tổng các tọa độ X và Y
    let totalX = 0;
    let totalY = 0;
    let count = features.length;
  
    features.forEach(feature => {
      const coords = feature.geometry.coordinates;
      totalX += coords[0];
      totalY += coords[1];
    });
  
    // Tính tọa độ trung tâm
    const centerX = totalX / count;
    const centerY = totalY / count;
  
    return [centerX, centerY ];
  }